package ui.pages

import emotion.react.css
import helpers.takeIfNotUndefined
import js.errors.JsError
import js.errors.name
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.router.useNavigate
import react.router.useNavigation
import react.router.useRouteError
import ui.router.RouterRoute
import ui.styles.Styles
import utils.logger.log
import web.cssom.*

val ErrorPage = FC<Props> {
    val error = useRouteError().unsafeCast<JsError>()
    val navigators = useNavigate()

    val messageFromError = error.message.takeIfNotUndefined(null)

    log.e("[ErrorPage] messageFromError: ${listOf(
        error.cause,
        error.message,
        error.name,
        error.stackTraceToString()
    )}")

    ReactHTML.div{
        className = Styles.ErrorPage.errorPageContainer

        css(className) {

        }

//        ReactHTML.div{
//            css {
//                height = 50.px
//                width = 50.px
//                position = Position.fixed
//                left = 50.pct
//                top = 0.px
//                border = Border(
//                    width = 1.px,
//                    style = LineStyle.solid,
//                    color = Color("white")
//                )
//                borderRadius = 50.pct
//                transform = translate((-50).pct)
//            }
//        }

        ReactHTML.span{

            css {
                fontSize = 26.vh

                textDecoration = TextDecoration.underline
                textDecorationThickness = 1.vh

                hover {
                    cursor = Cursor.pointer
                    opacity = number(0.7)
                }
            }

            onClick = {
                navigators(to = RouterRoute.MAIN_PAGE.route)
            }

            +"404"
        }

        if (messageFromError != null) {
            ReactHTML.span{
                +"ERROR: ${error.message}"
            }
            ReactHTML.span{
                +"CAUSE: ${error.cause}"
            }
        }
        if (error.name.toString() != "null"){
            ReactHTML.span{
                +"NAME: ${error.name}"
            }
            ReactHTML.span{
                +"STACK: ${error.stackTraceToString()}"
            }
        }
    }
}